import React from 'react'
import { Modal, Pressable } from 'react-native'

import { Icon, SH1, Select, Stack, XStack } from '@zet/design-system'

import { i18n } from '../../../localization'
import { YoutubeVideoDetailsType } from '../../../types'

const languageData = [
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'Hindi' },
]

type ChangeLanguageBottomSheetProps = {
  isBottomSheetVisible: boolean
  setIsBottomSheetVisible: () => void
  selectedLanguageVideo: YoutubeVideoDetailsType
  selectedLanguage: string
  setSelectedLanguage: () => void
}

const ChangeLanguageBottomSheet = ({
  isBottomSheetVisible,
  setIsBottomSheetVisible,
  selectedLanguageVideo,
  selectedLanguage,
  setSelectedLanguage,
}: ChangeLanguageBottomSheetProps) => {
  const onChangeSelect = (value: string) => {
    setSelectedLanguage(value)
    setIsBottomSheetVisible(false)
  }

  const closeBottomSheet = () => {
    setIsBottomSheetVisible(false)
  }

  let screenWidth
  if (selectedLanguageVideo?.isPortrait) {
    screenWidth = 'w-full'
  } else {
    screenWidth = 'w-3/4'
  }

  return (
    <Stack className="flex flex-1 items-end justify-end">
      <Modal
        animationType="slide"
        transparent={true}
        visible={isBottomSheetVisible}
        onRequestClose={closeBottomSheet}
      >
        <Stack
          className="flex flex-1 items-center justify-end"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
          <Stack className={`rounded-t-lg bg-white p-4 ${screenWidth}`}>
            <XStack className={`items-start justify-between px-2 py-2`}>
              <XStack className="items-center">
                <Icon type="LanguageFilled" size={24} />
                <SH1 className=" ml-[12] ">
                  {i18n.t('preRecordedTraining.selectVideoLanguage')}
                </SH1>
              </XStack>
              <Pressable className="self-center" onPress={closeBottomSheet}>
                <Icon size={24} type="Close" />
              </Pressable>
            </XStack>
            <Stack className="mt-3">
              <Select onChange={onChangeSelect}>
                {languageData.map((op, i) => (
                  <Select.Option
                    key={op?.value}
                    showToggle={false}
                    name={op?.value}
                    selectedValue={selectedLanguage}
                    optionContainerStyle="h-[62] mb-3 w-full justify-center rounded-lg"
                  >
                    <SH1>{op?.label}</SH1>
                  </Select.Option>
                ))}
              </Select>
            </Stack>
          </Stack>
        </Stack>
      </Modal>
    </Stack>
  )
}

export { ChangeLanguageBottomSheet }
